<script setup>
definePage({
  meta: {
    action: 'read',
    subject: 'Med',
    navActiveLink: 'operational-infractions',
  },
})

import InfractionsPage from './index.vue'
</script>

<template>
  <InfractionsPage />
</template>
